import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload, faXmark } from "@fortawesome/free-solid-svg-icons";
import "./FilesPopup.css";
import api from "../../../services/BackendServices";

function FilesPopup({ files, onClose, setSelectedFile, userId }) {
  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    };
    return new Intl.DateTimeFormat("es-ES", options).format(
      new Date(dateString)
    );
  };

  const handleFileSelect = async (filename) => {
    console.log("Fetching file:", filename);
    try {
      const response = await api.GeneralServices.selectFile(userId, filename);
      const blob = response.data;

      const file = new File([blob], filename, { type: blob.type });
      console.log("Selected file:", file);

      setSelectedFile(file); // Notifica a ChatBar del archivo seleccionado
      onClose(); // Cierra el popup
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="files-popup">
      <div className="popup-content">
        <button className="close-popup" onClick={onClose}>
          <FontAwesomeIcon icon={faXmark} />
        </button>
        <h2>Mis Archivos</h2>
        <ul>
          {files.length > 0 ? (
            files.map((file, index) => (
              <li key={index}>
                <button
                  className="file-item"
                  onClick={() => handleFileSelect(file.fileName)}
                >
                  <FontAwesomeIcon icon={faFileDownload} /> {file.fileName} -{" "}
                  {formatDate(file.uploaded_at)}
                </button>
              </li>
            ))
          ) : (
            <li>No hay archivos subidos.</li>
          )}
        </ul>
      </div>
    </div>
  );
}

export default FilesPopup;
